import React from 'react';
// import { NextSeo } from 'next-seo';
import { NextRouter, withRouter } from 'next/router';

interface StyleGuidePageProps {
  router: NextRouter;
  lang?: string;
}

const StylGuidePage: React.FC<StyleGuidePageProps> = () => {
  return (
    <>
      <h1>v-PaSSer Style Guides</h1>
      <h2>Color</h2>
      <table width="100%">
        <tr>
          <td>Primary</td>
          <td>
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--primary-dark-navy"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--primary-navy"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--primary-dark-blue"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--primary-blue"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--primary-light-blue"
            />
          </td>
        </tr>
        <tr>
          <td>Secondary</td>
          <td>
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-dark-red"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-red"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-dark-orange"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-orange"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-light-orange"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-yellow"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-green"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--secondary-dark-green"
            />
          </td>
        </tr>
        <tr>
          <td>Grey scale</td>
          <td>
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--black"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--grey-400"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--grey-300"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--grey-200"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--grey-100"
            />
            <span
              style={{ display: 'inline-block', width: '42px', height: '42px', marginRight: '10px' }}
              className="a-color__bg--white"
            />
          </td>
        </tr>
      </table>

      <br />
      <br />

      <h2>Typeface</h2>
      <table width="100%">
        <tr>
          <td>Element</td>
          <td>Font</td>
          <td>Weight</td>
          <td>Size (PC / SP)</td>
          <td>Line height (PC / SP)</td>
        </tr>
        <tr>
          <td>
            <h1>H1</h1>
          </td>
          <td>
            <h1>Raleway</h1>
          </td>
          <td>
            <h1>medium</h1>
          </td>
          <td>
            <h1>60 / 40</h1>
          </td>
          <td>
            <h1>80 / 58</h1>
          </td>
        </tr>
        <tr>
          <td>
            <h2>H2</h2>
          </td>
          <td>
            <h2>Raleway</h2>
          </td>
          <td>
            <h2>medium</h2>
          </td>
          <td>
            <h2>40 / 24</h2>
          </td>
          <td>
            <h2>54 / 39</h2>
          </td>
        </tr>
        <tr>
          <td>
            <h3>H3</h3>
          </td>
          <td>
            <h3>Raleway</h3>
          </td>
          <td>
            <h3>bold</h3>
          </td>
          <td>
            <h3>30 / 22</h3>
          </td>
          <td>
            <h3>48 / 36</h3>
          </td>
        </tr>
        <tr>
          <td>
            <h4>H4</h4>
          </td>
          <td>
            <h4>Raleway</h4>
          </td>
          <td>
            <h4>bold</h4>
          </td>
          <td>
            <h4>22 / 20</h4>
          </td>
          <td>
            <h4>36 / 32</h4>
          </td>
        </tr>
        <tr>
          <td>
            <h5>H5</h5>
          </td>
          <td>
            <h5>Raleway</h5>
          </td>
          <td>
            <h5>extra bold</h5>
          </td>
          <td>
            <h5>20 / 18</h5>
          </td>
          <td>
            <h5>32 / 28</h5>
          </td>
        </tr>
        <tr>
          <td>
            <h6>H6</h6>
          </td>
          <td>
            <h6>Raleway</h6>
          </td>
          <td>
            <h6>bold</h6>
          </td>
          <td>
            <h6>14 / 14</h6>
          </td>
          <td>
            <h6>24 / 24</h6>
          </td>
        </tr>
        <tr>
          <td>
            <span className="a-text--body-1">Body 1</span>
          </td>
          <td>
            <span className="a-text--body-1">Arial</span>
          </td>
          <td>
            <span className="a-text--body-1">regular</span>
          </td>
          <td>
            <span className="a-text--body-1">20 / 19</span>
          </td>
          <td>
            <span className="a-text--body-1">32 / 36</span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="a-text--body-2">Body 2</span>
          </td>
          <td>
            <span className="a-text--body-2">Arial</span>
          </td>
          <td>
            <span className="a-text--body-2">regular</span>
          </td>
          <td>
            <span className="a-text--body-2">16 / 16</span>
          </td>
          <td>
            <span className="a-text--body-2">32 / 32</span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="a-text--caption">Caption</span>
          </td>
          <td>
            <span className="a-text--caption">Arial</span>
          </td>
          <td>
            <span className="a-text--caption">regular</span>
          </td>
          <td>
            <span className="a-text--caption">12 / 12</span>
          </td>
          <td>
            <span className="a-text--caption">24 / 24</span>
          </td>
        </tr>
      </table>
    </>
  );
};

export default withRouter(StylGuidePage);
